import { addDays, format, getDay } from 'date-fns';

export interface PainelOption {
  id: number;
  label: string;
  config: {
    dias_previsao: number;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

const SEXTA = 5; // date-fns: domingo=0, sexta=5, sabado=6

export function derivarPeriodoEixoX(
  dataRodada: string,
  idModelosSelecionados: number[],
  painelOptions: PainelOption[],
): { dataInicio: string; dataFim: string } {
  // Extrair dias_previsao dos modelos selecionados
  const diasPrevisao = idModelosSelecionados
    .map((id) => painelOptions.find((o) => o.id === id)?.config?.dias_previsao ?? 0)
    .filter((d) => d > 0);

  // Se nenhum modelo com dias_previsao valido, fallback: mesmo dia
  if (diasPrevisao.length === 0) {
    return { dataInicio: dataRodada, dataFim: dataRodada };
  }

  // MAX dos dias_previsao
  const maxDias = Math.max(...diasPrevisao);

  // Parse dataRodada como data local (evita offset UTC)
  const parseISOLocal = (iso: string): Date => new Date(iso.replace(/-/g, '/'));
  const inicio = parseISOLocal(dataRodada);
  const fimBase = addDays(inicio, maxDias);

  // Arredondar para proxima sexta-feira
  // delta = 0 se ja for sexta, senao dias ate proxima sexta
  const delta = (SEXTA - getDay(fimBase) + 7) % 7;
  const fim = addDays(fimBase, delta);

  return {
    dataInicio: format(inicio, 'yyyy-MM-dd'),
    dataFim: format(fim, 'yyyy-MM-dd'),
  };
}
